import PhoneNumber from './PhoneNumber';

export default function getExampleNumber(country, examples, metadata) {
	if (examples[country]) {
		return new PhoneNumber(country, examples[country], metadata);
	}
}
//# sourceMappingURL=getExampleNumber.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/libphonenumber-js/es6/getExampleNumber.js
// module id = ../../../../libphonenumber-js/es6/getExampleNumber.js
// module chunks = 3